import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./CustomColorInput.module.css";

import Button from "../Button";

/**
 * Interactive component. An input component that allows the user to input a color value.
 */
export function CustomColorInput({ setCustomColor, customColor }) {
  const [tempColor, setTempColor] = useState(customColor ?? "");

  return (
    <div className={styles.container}>
      <label hidden htmlFor="custom-color-input">
        Custom Color
      </label>
      <input
        type="text"
        value={tempColor}
        onChange={(e) => setTempColor(e.target.value)}
        name="custom-color-input"
        className={styles.input}
      />
      <Button
        text="Set"
        className={styles.button}
        onClick={() => setCustomColor(tempColor.trim())}
      />
    </div>
  );
}

CustomColorInput.propTypes = {
  /**
   * Function that fires when the set button is clicked.
   */
  setCustomColor: PropTypes.func,
  /**
   * The input value.
   */
  customColor: PropTypes.string,
};
